import { Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import MainApi from "../../../services/mainApi.service";
import { ICompanyDigitalCertificates } from "../../../models/company-digital-certificate";
import { Chip } from "@mui/material";
import { formatCompanyDigitalCertificateDocument } from "./digitalCertificateDocument";

const DIGITAL_CERTIFICATES_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/CompanyDigitalCertificate/";
const digitalCertificatesService = new MainApi<ICompanyDigitalCertificates>(
  DIGITAL_CERTIFICATES_ROUTE,
);

const translationPath = "page.register.digital_certificates.";

const DigitalCertificatesPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const columns: GridColDef<ICompanyDigitalCertificates>[] = useMemo(
    () => [
      {
        field: "name",
        headerName: t(translationPath + "name") || "Name",
      },
      {
        field: "typeDocumentName",
        headerName: t(translationPath + "type_document") || "",
        minWidth: 180,
        flex: 1,
        renderCell: ({
          row: { typeDocument, typeDocumentName, typeDocumentCode },
        }) =>
          typeDocumentName ||
          typeDocument?.value ||
          typeDocument?.name ||
          typeDocumentCode ||
          "",
      },
      {
        field: "document",
        headerName: t(translationPath + "document") || "",
        minWidth: 180,
        flex: 1,
        renderCell: ({ row }) => formatCompanyDigitalCertificateDocument(row),
      },
      {
        field: "enable",
        headerName: t(translationPath + "status") || "Status",
        renderCell: (params) => (
          <Chip
            size="small"
            color={params.value ? "success" : "error"}
            label={
              params.value
                ? t(translationPath + "active")
                : t(translationPath + "inactive")
            }
          />
        ),
      },
      {
        field: "useCertillionLocalAgent",
        headerName:
          t(translationPath + "useCertillionLocalAgent") || "Certillion local",
        renderCell: (params) => (
          <Chip
            size="small"
            color={params.value ? "success" : "error"}
            label={
              params.value ? t(translationPath + "yes") : t(translationPath + "no")
            }
          />
        ),
      },
    ],
    [t],
  );

  const handleRowClick = (
    params: GridRowParams<ICompanyDigitalCertificates>,
  ) => {
    navigate(`${params.id.toString()}/edit`);
  };

  const handleAdd = () => {
    navigate("new");
  };

  return (
    <Table<ICompanyDigitalCertificates>
      showDefaultMacroFilters={false}
      service={digitalCertificatesService}
      columns={columns}
      title={t(translationPath + "digital_certificates")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={
        t(translationPath + "search_digital_certificate") ||
        "Searh for a digital certificate"
      }
      addButtonLabel={
        t(translationPath + "add_digital_certificate") ||
        "Add Digital Certificate"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default DigitalCertificatesPage;
